import { render, staticRenderFns } from "./KETConstructionDefectDetails.vue?vue&type=template&id=b3770dba&"
import script from "./KETConstructionDefectDetails.vue?vue&type=script&lang=js&"
export * from "./KETConstructionDefectDetails.vue?vue&type=script&lang=js&"
import style0 from "./KETConstructionDefectDetails.vue?vue&type=style&index=0&id=b3770dba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports